import React, { useEffect, useState } from "react";
import api from "../../../../api/axios";
import conf_room_img from "../../../../assets/images/round-table-icon.svg";
import meeting_room_img from "../../../../assets/images/meeting-room-icon.svg";

const KOT = () => {
  const [kotList, setKotList] = useState([]);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [printData, setPrintData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    loadKOT();
  }, []);

  const loadKOT = async () => {
    try {
      setIsLoading(true);
      const res = await api.get("/pms/pos/sales");
      setKotList(res.data);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (printData) {
      setTimeout(() => {
        const content = document.getElementById("print-area").innerHTML;

        const win = window.open("", "_blank", "width=300,height=600");
        win.document.write(`
        <html>
          <head>
            <title>Thermal Preview</title>

            <style>
              @page {
                size: 58mm auto !important;
                margin: 0 !important;
              }

              html, body {
                margin: 0 !important;
                padding: 0 !important;
                width: 58mm !important;
                overflow: hidden !important;
                font-family: monospace !important;
                font-size: 10px !important;
                line-height: 1.2 !important;
              }

              * {
                box-sizing: border-box !important;
                max-width: 58mm !important;
              }

              hr {
                border: none;
                border-top: 1px dashed #000;
                margin: 4px 0;
              }

              table {
                width: 100% !important;
                border-collapse: collapse !important;
              }

              td, th {
                padding: 0;
                white-space: nowrap !important;
                font-size: 10px !important;
              }
            </style>

          </head>

          <body>
            ${content}
          </body>
        </html>
      `);

        win.document.close();
        win.focus();
        setPrintData(null);
      }, 300);
    }
  }, [printData]);

  return (
    <div className="px-xl-5 px-lg-4 px-3 py-3 page-body">
      <div className="row g-3">
        <div className="col-sm-12">
          <h3 className="fw-bold mb-0">KOT</h3>
        </div>

        {/* KOT CARDS */}
        <div className="col-sm-12">
          <ul className="row g-2 list-unstyled row-cols-lg-4 row-cols-md-3 row-cols-sm-2 row-cols-1">
            {kotList.map((data, index) => (
              <li className="col" key={index}>
                <div className="card room-cards p-3 h-100">
                  {/* Header */}
                  <div className="d-flex align-items-center gap-2">
                    <img
                      src={
                        data.service_type?.toLowerCase() === "table"
                          ? conf_room_img
                          : meeting_room_img
                      }
                      className="room-type-icon"
                      alt="room_type_icon"
                    />

                    <div className="d-flex flex-column">
                      <span className="kot-card-id">KOT-{data.id}</span>
                      <span className="kot-card-service">
                        {data.service_type.charAt(0).toUpperCase() +
                          data.service_type.slice(1)}
                      </span>
                    </div>
                  </div>

                  {/* Customer Name */}
                  <h6 className="kot-card-gname mt-2">
                    {data.customer_name || "Walk-in"}
                  </h6>

                  {data.service_type === "table" && (
                    <p className="m-0 text-muted">Table No: {data.table_no}</p>
                  )}

                  {/* Room number if service_type = room */}
                  {data.service_type === "room" && (
                    <p className="m-0 text-muted">Room No: {data.room_no}</p>
                  )}

                  {/* Items */}
                  <div className="d-flex justify-content-between mt-2">
                    <ul className="list-unstyled mb-0">
                      {data.items?.map((item, i) => (
                        <li key={i} className="kot-meal-type">
                          <span>{item.name}</span> -{" "}
                          <span>{item.quantity}</span>
                        </li>
                      ))}
                    </ul>

                    {/* Buttons */}
                    {/* <div className="d-flex flex-column justify-content-end">
                      <button
                        className="btn kot-primary-btn"
                        onClick={() => setSelectedInvoice(data)}
                      >
                        Invoice
                      </button>

                      <button
                        className="btn kot-secondary-btn"
                        onClick={() => setPrintData(data)}
                      >
                        Thermal Print
                      </button>
                    </div> */}
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* ---------------- INVOICE MODAL ---------------- */}
      {selectedInvoice && (
        <div
          className="modal fade show d-block"
          style={{ background: "#00000055" }}
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content rounded-4 p-4">
              <h4 className="fw-bold mb-3">
                Invoice: {selectedInvoice.invoice_no}
              </h4>

              <div className="mb-2">
                <strong>Customer:</strong>{" "}
                {selectedInvoice.customer_name || "Walk-in"}
              </div>

              {selectedInvoice.service_type === "room" && (
                <div className="mb-2">
                  <strong>Room No:</strong> {selectedInvoice.room_no}
                </div>
              )}

              <div className="mb-2">
                <strong>Service Type:</strong> {selectedInvoice.service_type}
              </div>

              <div className="mb-2">
                <strong>Date:</strong>{" "}
                {new Date(selectedInvoice.created_at).toLocaleString("en-IN")}
              </div>

              <hr />

              {/* Invoice Items Table */}
              <table className="table table-bordered">
                <thead className="table-light">
                  <tr>
                    <th>Item</th>
                    <th>Qty</th>
                    <th>Price</th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedInvoice.items?.map((item, i) => (
                    <tr key={i}>
                      <td>{item.name}</td>
                      <td>{item.quantity}</td>
                      <td>{item.unit_price}</td>
                      <td>{item.line_total}</td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <div className="text-end">
                <p>
                  <strong>Subtotal:</strong> {selectedInvoice.subtotal}
                </p>
                <p>
                  <strong>Tax:</strong> {selectedInvoice.tax}
                </p>
                <h5>
                  <strong>Total:</strong> {selectedInvoice.total}
                </h5>
                <p>
                  <strong>Payment Mode:</strong> {selectedInvoice.payment_mode}
                </p>
              </div>

              <div className="d-flex justify-content-end gap-2 mt-3">
                <button
                  className="btn btn-secondary"
                  onClick={() => window.print()}
                >
                  Print
                </button>

                <button
                  className="btn btn-danger"
                  onClick={() => setSelectedInvoice(null)}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ---------------- THERMAL PRINT TEMPLATE ---------------- */}
      {/* SMALL 58mm THERMAL PRINT TEMPLATE */}
      {printData && (
        <div className="d-none">
          <div
            id="print-area"
            style={{
              width: "58mm",
              padding: "4px",
              fontFamily: "monospace",
              fontSize: "10px",
              lineHeight: "1.2",
            }}
          >
            {/* Header */}
            <div style={{ textAlign: "center", marginBottom: "5px" }}>
              <h3 style={{ margin: 0, fontSize: "14px" }}>HOTEL NAME</h3>
              <p style={{ margin: 0 }}>Address Line</p>
              <p style={{ margin: 0 }}>Phone: +91 XXXXXXXXXX</p>
            </div>

            <hr style={{ margin: "4px 0" }} />

            {/* Basic Info */}
            <p style={{ margin: "2px 0" }}>
              <strong>KOT:</strong> {printData.id}
            </p>
            <p style={{ margin: "2px 0" }}>
              <strong>Invoice:</strong> {printData.invoice_no}
            </p>
            <p style={{ margin: "2px 0" }}>
              <strong>Date:</strong>{" "}
              {new Date(printData.created_at).toLocaleString("en-IN")}
            </p>

            {printData.service_type === "room" && (
              <p style={{ margin: "2px 0" }}>
                <strong>Room:</strong> {printData.room_no}
              </p>
            )}

            <p style={{ margin: "2px 0" }}>
              <strong>Customer:</strong> {printData.customer_name || "Walk-in"}
            </p>

            <hr style={{ margin: "4px 0" }} />

            {/* Items Table */}
            <table style={{ width: "100%", fontSize: "11px" }}>
              <tbody>
                {printData.items?.map((item, i) => (
                  <tr key={i}>
                    <td style={{ width: "55%" }}>{item.name}</td>
                    <td style={{ width: "10%", textAlign: "center" }}>
                      {item.quantity}
                    </td>
                    <td style={{ width: "15%", textAlign: "right" }}>
                      {item.unit_price}
                    </td>
                    <td style={{ width: "20%", textAlign: "right" }}>
                      {item.line_total}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            <hr style={{ margin: "4px 0" }} />

            {/* Totals */}
            <p style={{ textAlign: "right", margin: "2px 0" }}>
              Sub: {printData.subtotal}
            </p>
            <p style={{ textAlign: "right", margin: "2px 0" }}>
              Tax: {printData.tax}
            </p>
            <h4
              style={{ textAlign: "right", margin: "4px 0", fontSize: "13px" }}
            >
              Total: {printData.total}
            </h4>

            <p style={{ marginTop: "4px" }}>
              <strong>Payment:</strong> {printData.payment_mode}
            </p>

            <hr style={{ margin: "4px 0" }} />

            <p style={{ textAlign: "center", fontSize: "11px" }}>
              Thank you! Visit Again.
            </p>
          </div>
        </div>
      )}
      {isLoading && (
        // <div
        //   style={{
        //     position: "fixed",
        //     top: 0,
        //     left: 0,
        //     width: "100vw",
        //     height: "100vh",
        //     // background: "rgba(0,0,0,0.45)",
        //     // zIndex: 999999,
        //     display: "flex",
        //     justifyContent: "center",
        //     alignItems: "center",
        //     backdropFilter: "blur(2px)",
        //   }}
        // >
        <div
          className="spinner-border text-light"
          style={{ width: "3rem", height: "3rem" }}
        ></div>
        // </div>
      )}
    </div>
  );
};

export default KOT;
